import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SearchBy = ({
    dropdownRef,
    setShowDropdown,
    showDropdown, 
    selectedSearchField, 
    getSelectedOption, 
    searchOptions, 
    handleSearchFieldSelect, 
    statusDropdownRef, 
    setShowStatusDropdown, 
    showStatusDropdown, 
    statusOptions, 
    handleStatusSelect,
    userTypeDropdownRef,
    setShowUserTypeDropdown,
    showUserTypeDropdown,
    userTypeOptions,
    handleUserTypeSelect,
    searchDate, 
    setSearchDate, 
    activeFilters, 
    setActiveFilters,
    searchValue,
    fetchContacts,
    setSearchValue,
    handleSearch,
    setSelectedSearchField,
    clearFilters,
    engagementDropdownRef,
    setShowEngagementDropdown, 
    showEngagementDropdown,
    engagementOptions,
    handleEngagementSelect,
}) => {

    const location = useLocation();
    const isContactPage = location.pathname === '/contact';
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        setUserName(user?.role);
      }, []);

    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const getTomorrowDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split('T')[0];
    };

    const isFutureDateField = (fieldValue) => {
        return false;
    };

    const shouldShowTextInput = () => {
        const option = getSelectedOption();
        return selectedSearchField && 
               selectedSearchField !== 'status' && 
               selectedSearchField !== 'userType' &&
               selectedSearchField !== 'engagement_stage' && 
               option && !option.isDate;
    };

    const shouldShowQuickDateButtons = () => {
        const option = getSelectedOption();
        return option?.isDate && (
            selectedSearchField === 'created_at' || 
            selectedSearchField === 'nextFollowupCall' || 
            selectedSearchField === 'nextFollowupMail'
        );
    };

    const handleQuickDateSelect = (dateType) => {
        const selectedDate = dateType === 'today' ? getTodayDate() : getTomorrowDate();
        setSearchDate(selectedDate);
        
        const newFilters = {
            ...activeFilters,
            [selectedSearchField]: selectedDate
        };
        setActiveFilters(newFilters);
        fetchContacts(1, newFilters);
    };

    return (
        <div className={`flex ${isContactPage && userName === 'ADMIN' ? 'flex-col' : 'flex-row mb-0'} items-start gap-2`}>
            <div className="relative" ref={dropdownRef}>
                <button
                    onClick={() => setShowDropdown(!showDropdown)}
                    className="flex items-center justify-between min-w-48 px-4 py-2 border-2 border-blue-200 rounded-lg bg-gradient-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-200 shadow-sm"
                >
                    <span className="text-gray-700 font-medium">
                        {selectedSearchField ? getSelectedOption()?.label : 'Search By'}
                    </span>
                    <svg
                        className={`w-5 h-5 transition-transform duration-200 ${showDropdown ? 'transform rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>

                {showDropdown && (
                    <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden">
                        {searchOptions.map((option) => (
                            <button
                                key={option.value}
                                onClick={() => handleSearchFieldSelect(option)}
                                className="w-full text-left px-3 py-2 hover:bg-gradient-to-r hover:from-blue-50 hover:to-yellow-50 focus:outline-none transition-all duration-150 border-b border-gray-100 last:border-b-0"
                            >
                                <div className="flex items-center">
                                    <span className="text-sm font-medium text-gray-700">{option.label}</span>
                                    {option.isDate && (
                                        <span className="ml-2 px-1.5 py-0.5 text-[0.65rem] bg-yellow-100 text-yellow-700 rounded-full">Date</span>
                                    )}
                                    {option.isEngagement && (
                                        <span className="ml-2 px-1.5 py-0.5 text-[0.65rem] bg-green-100 text-green-700 rounded-full">Engagement</span>
                                    )}
                                </div>
                            </button>
                        ))}
                    </div>
                )}
            </div>

           <div className={`flex flex-row items-center gap-2 ${isContactPage && userName === "ADMIN" ? 'mb-3' : 'mb-0'}`}>
            {selectedSearchField === 'status' && (
                <div className="relative" ref={statusDropdownRef}>
                    <button
                        onClick={() => setShowStatusDropdown(!showStatusDropdown)}
                        className="flex items-center justify-between min-w-48 px-4 py-2 border-2 border-yellow-200 rounded-lg bg-gradient-to-r from-yellow-50 to-yellow-100 hover:from-yellow-100 hover:to-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-300 transition-all duration-200 shadow-sm"
                    >
                        <span className="text-gray-700 font-medium">Select Status</span>
                        <svg
                            className={`w-5 h-5 transition-transform duration-200 ${showStatusDropdown ? 'transform rotate-180' : ''}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    {showStatusDropdown && (
                        <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden">
                            {statusOptions.map((status) => (
                                <button
                                    key={status.value}
                                    onClick={() => handleStatusSelect(status)}
                                    className="w-full text-left px-3 py-2 hover:bg-gradient-to-r hover:from-yellow-50 hover:to-blue-50 focus:outline-none transition-all duration-150 border-b border-gray-100 last:border-b-0"
                                >
                                    <span className="text-sm font-medium text-gray-700">{status.label}</span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {selectedSearchField === 'userType' && (
                <div className="relative" ref={userTypeDropdownRef}>
                    <button
                        onClick={() => setShowUserTypeDropdown(!showUserTypeDropdown)}
                        className="flex items-center justify-between min-w-48 px-4 py-2 border-2 border-purple-200 rounded-lg bg-gradient-to-r from-purple-50 to-purple-100 hover:from-purple-100 hover:to-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-300 transition-all duration-200 shadow-sm"
                    >
                        <span className="text-gray-700 font-medium">Select User Type</span>
                        <svg
                            className={`w-5 h-5 transition-transform duration-200 ${showUserTypeDropdown ? 'transform rotate-180' : ''}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    {showUserTypeDropdown && (
                        <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden">
                            {userTypeOptions && userTypeOptions.map((userType) => (
                                <button
                                    key={userType.value}
                                    onClick={() => handleUserTypeSelect(userType)}
                                    className="w-full text-left px-3 py-2 hover:bg-gradient-to-r hover:from-purple-50 hover:to-blue-50 focus:outline-none transition-all duration-150 border-b border-gray-100 last:border-b-0"
                                >
                                    <span className="text-sm font-medium text-gray-700">{userType.label}</span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {selectedSearchField === 'engagement_stage' && (
                <div className="relative" ref={engagementDropdownRef}>
                    <button
                        onClick={() => {
                            if (setShowEngagementDropdown) {
                                setShowEngagementDropdown(!showEngagementDropdown);
                            }
                        }}
                        className="flex items-center justify-between min-w-48 px-4 py-2 border-2 border-green-200 rounded-lg bg-gradient-to-r from-green-50 to-green-100 hover:from-green-100 hover:to-green-200 focus:outline-none focus:ring-2 focus:ring-green-300 transition-all duration-200 shadow-sm"
                    >
                        <span className="text-gray-700 font-medium">Select Engagement</span>
                        <svg
                            className={`w-5 h-5 transition-transform duration-200 ${showEngagementDropdown ? 'transform rotate-180' : ''}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    {showEngagementDropdown && (
                        <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl z-20 overflow-hidden">
                            {engagementOptions.map((engagement) => (
                                <button
                                    key={engagement.value}
                                    onClick={() => handleEngagementSelect(engagement)}
                                    className="w-full text-left px-3 py-2 hover:bg-gradient-to-r hover:from-green-50 hover:to-blue-50 focus:outline-none transition-all duration-150 border-b border-gray-100 last:border-b-0"
                                >
                                    <span className="text-sm font-medium text-gray-700">{engagement.label}</span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            )}

           
             {selectedSearchField && selectedSearchField !== 'status' && selectedSearchField !== 'userType' && selectedSearchField !== 'engagement_stage' && (
                <div className="flex items-center gap-2">
                    {getSelectedOption()?.isDate ? (
                        <div className="flex items-center gap-2">
                            {/* Quick Date Selection Buttons */}
                            {shouldShowQuickDateButtons() && (
                                <div className="flex flex-col gap-[2.5px] pt-[1px]">
                                    <button
                                        onClick={() => handleQuickDateSelect('today')}
                                        className="px-2 py-[1px] text-[0.7rem] bg-[#4197d1] hover:bg-[#3985b6] text-white rounded font-medium focus:outline-none focus:ring-1 focus:ring-blue-300 transition-all duration-200 shadow-sm hover:shadow-md"
                                    >
                                        Today
                                    </button>
                                    <button
                                        onClick={() => handleQuickDateSelect('tomorrow')}
                                        className="px-2 py-[1.2px] text-[0.7rem] bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded font-medium focus:outline-none focus:ring-1 focus:ring-green-300 transition-all duration-200 shadow-sm hover:shadow-md"
                                    >
                                        Tomorrow
                                    </button>
                                </div>
                            )}
                            
                            <input
                                type="date"
                                value={searchDate}
                                onChange={(e) => setSearchDate(e.target.value)}
                                min={isFutureDateField(selectedSearchField) ? getTodayDate() : undefined}
                                className="px-4 py-1.5 border-2 w-48 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-300 transition-all duration-200 date-input"
                            />
                            <button
                                onClick={() => {
                                    if (searchDate) {
                                        const newFilters = {
                                            ...activeFilters,
                                            [selectedSearchField]: searchDate
                                        };
                                        setActiveFilters(newFilters);
                                        fetchContacts(1, newFilters);
                                    }
                                }}
                                className="px-6 py-2 bg-[#3985b6] hover:bg-[#2b6a94] text-white rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-200 shadow-md hover:shadow-lg"
                            >
                                Search
                            </button>
                        </div>
                    ) : shouldShowTextInput() ? (
                        <>
                            <input
                                type="text"
                                placeholder={`Enter ${getSelectedOption()?.label}`}
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                className="px-4 py-2 border-2 border-gray-200 rounded-lg w-48 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-300 transition-all duration-200"
                            />
                            
                            <button
                                onClick={handleSearch}
                                className="px-6 py-2 bg-[#3985b6] hover:bg-[#2b6a94] text-white rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-200 shadow-md hover:shadow-lg"
                            >
                                Search
                            </button>
                        </>
                    ) : null}
                    
                    {(selectedSearchField || searchValue || searchDate) && Object.keys(activeFilters).length === 0 && (
                        <button
                            onClick={() => {
                                setSelectedSearchField('');
                                setSearchValue('');
                                setSearchDate('');
                                setShowStatusDropdown(false);
                                if (setShowUserTypeDropdown) {
                                    setShowUserTypeDropdown(false);
                                }
                                if (setShowEngagementDropdown) {
                                    setShowEngagementDropdown(false);
                                }
                            }}
                            className="p-2 text-gray-500 hover:text-red-500 hover:bg-red-50 rounded-full transition-all duration-200"
                            title="Clear search field"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    )}
                </div>
            )}

            {Object.keys(activeFilters).length > 0 && (
                <button
                    onClick={clearFilters}
                    className="w-8 h-8 flex items-center justify-center text-red-600 hover:text-red-700 hover:bg-red-50 rounded-full transition-all duration-200"
                    title="Clear all filters"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            )}
           </div>
        </div>
    );
};

export default SearchBy;